import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { PenToSquareIcon } from '../../theme/Icons';
import { ViewNoteSection } from './ViewNoteSection';
import { LinkText } from '../../components/LinkText';
import { SelectableText } from '../../components/SelectableText';
import { noteBodyText } from '../noteBodyText';

const useStyles = createUseStyles({
    plainTextBody: {
        whiteSpace: 'pre-line'
    }
});

export const UserNotes: FC<{ content: string; editHandler?: () => void; hasAISummary?: boolean; }> = ({ content, editHandler, hasAISummary }) => {
    const classes = useStyles();
    if (!content && !editHandler) {
        return null;
    }
    return (
        <div style={{marginTop: 8}}>
            <ViewNoteSection title="Your Notes" Icon={PenToSquareIcon}>
                {content ? (
                    <div className={`mp-mask ${classes.plainTextBody}`}>
                        <SelectableText>{noteBodyText(content)}</SelectableText>
                    </div>
                ): (
                    <div>
                        {editHandler &&
                            <><LinkText data-type="edit-link" onClick={editHandler}>Edit</LinkText> to add {hasAISummary ? 'your own ' : ''}notes.</>
                        }
                    </div>
                )}
            </ViewNoteSection>
        </div>
    );
};
